module.exports = __webpack_public_path__ + "img/CharityStar.51225d39.png";